import { MemberChatPage } from '@/features/members';

export default function TeamMemberChatRoute() {
  return <MemberChatPage />;
}
